/**
 * Calculate age from birthday
 * @param birthday - The birthday date (can be Date object or ISO string)
 * @returns The age in years, or null if birthday is invalid
 */
export function calculateAge(birthday: Date | string | null | undefined): number | null {
  if (!birthday) return null;
  
  const birthDate = typeof birthday === 'string' ? new Date(birthday) : birthday;
  
  // Check if date is valid
  if (isNaN(birthDate.getTime())) return null;
  
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  // Adjust age if birthday hasn't occurred this year
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age;
}

/**
 * Validate if birthday results in valid age range for stories (2-12 years)
 * @param birthday - The birthday date
 * @returns true if age is between 2 and 12, false otherwise
 */
export function isValidChildBirthday(birthday: Date | string | null | undefined): boolean {
  const age = calculateAge(birthday);
  if (age === null) return false;
  return age >= 2 && age <= 12;
}

/**
 * Get age range boundaries for child birthday validation
 * @returns Object with minDate (12 years ago) and maxDate (2 years ago)
 */
export function getChildBirthdayRange() {
  const today = new Date();
  const maxDate = new Date(today.getFullYear() - 2, today.getMonth(), today.getDate());
  const minDate = new Date(today.getFullYear() - 12, today.getMonth(), today.getDate());
  
  return { minDate, maxDate };
}
